import { __decorate } from "tslib";
import { customElement, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ColumnTemplate as template } from './column.template';
/**
 * The Grid Pro Column element.
 * @remarks Used insde the Grid Pro element, to specify the column definitions (ColDef) for a given column.
 * @public
 */
let GridProColumn = class GridProColumn extends FoundationElement {
    constructor() {
        super(...arguments);
        this.definition = {};
    }
    slottedAgCellChanged() { }
};
__decorate([
    observable
], GridProColumn.prototype, "slottedAgCell", void 0);
__decorate([
    observable
], GridProColumn.prototype, "definition", void 0);
GridProColumn = __decorate([
    customElement({
        name: 'grid-pro-column',
        template,
    })
], GridProColumn);
export { GridProColumn };
